var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loader)?_c(_vm.loader,{tag:"component",attrs:{"filterData":_vm.filterData,"eventCategoryList":_vm.eventCategoryList,"sortData":_vm.sortData}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }